export default {
  ui: {
    isLoading: false,
  },
  dataTableFilters: [],
};
